import { useEffect } from 'react';
import { onDataChanged } from '../utils/dataBus';
import { llamarGoogleCalendar, EVENTO_GCAL } from '../utils/googleCalendar';

// Sincronizador automatico (no renderiza nada). Si el usuario vinculo Google
// Calendar:
//   - sincroniza una vez al abrir la app (cubre cambios que hizo el bot de
//     WhatsApp u otro usuario del estudio),
//   - y unos segundos despues de cualquier cambio propio en la agenda.
// Si no esta vinculado, solo hace una consulta de estado y se queda quieto.
const ESPERA_MS = 4000;

export default function GoogleCalendarSync({ estudioId }) {
  useEffect(() => {
    let cancelado = false;
    let conectado = false;
    let timer = null;

    async function sincronizar() {
      try { await llamarGoogleCalendar('sync'); } catch { /* se reintenta en el proximo cambio */ }
    }

    llamarGoogleCalendar('status')
      .then(st => {
        if (cancelado || !st?.connected) return;
        conectado = true;
        sincronizar();
      })
      .catch(() => {});

    const apagarBus = onDataChanged(() => {
      if (!conectado) return;
      clearTimeout(timer);
      timer = setTimeout(sincronizar, ESPERA_MS);
    }, ['agenda']);

    const alCambiarEstado = (e) => { conectado = !!e.detail?.connected; };
    window.addEventListener(EVENTO_GCAL, alCambiarEstado);

    return () => {
      cancelado = true;
      clearTimeout(timer);
      apagarBus();
      window.removeEventListener(EVENTO_GCAL, alCambiarEstado);
    };
  }, [estudioId]);

  return null;
}
